import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { PhotoViewerComponent } from 'src/app/photo-viewer/photo-viewer.component';
import { PatientService } from 'src/app/services/patient.service';
import { ToolService } from 'src/app/services/tool.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
})
export class PanelComponent implements OnInit {

  public data = null;

  constructor(private route: ActivatedRoute, private service : PatientService, private storage : Storage, private tool : ToolService, private modalController: ModalController) { }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.service.GetGraphy(id).toPromise()
    .catch(err =>{
      if(err){
        return;
      }
    })
    .then(res =>{      
      if(res){
        this.data = res.data[0];
        this.data.Date = this.tool.ConvertToPersianDateTime(this.data.Date);
      }
      });
  }

  ShowImage(data) {
    this.modalController.create({
      component: PhotoViewerComponent,
      componentProps: {
        'Data': data,
      }
    }).then(m => m.present());
  }

}
